<template>
  <!-- @mouseenter="(e) => fl_positionTooltip(e, { placement: 'top' })" -->
  <!-- class="number-input numinput csst" -->
  <div
    class="number-input numinput"
    @wheel="handleWheel"
    @click="focusInput(focusOperations)"
    @keydown.prevent.up="handleArrowUp"
    @keydown.prevent.down="handleArrowDown"
  >
    <!-- <div class="csst_content" style="position: fixed">
      <pre class="text-small">{{
        JSON.stringify(
          {
            value,
            min,
            max,
            step,
            focused,
            hasMinus,
            hasPlus,
            decimals,
            inputmode,
            focusOperations,
            tabindex
          },
          undefined,
          2
        )
      }}</pre>
    </div> -->
    <!-- {{ decimals }} -->
    <!-- @keydown="(e) => $emit('keydown', e.key)" -->
    <i
      v-if="hasMinus"
      class="mdi mdi-minus numinput_arrow numinput_arrow_minus icon_btn"
      :class="{
        'no-events numinput_arrow_disabled': value <= min,
      }"
      data-tst="minus"
      @mousedown="e => setMousedownTimeout(e, step * -1)"
      @mouseup="clearTimeout"
      @mouseout="clearTimeout"
    />
    <input
      ref="input"
      class="numinput_input"
      type="text"
      :value="value"
      :step="step"
      :inputmode="inputmode"
      :tabindex="tabindex"
      :data-tst="`${tstPrefix}number_input`"
      @click.stop
      @input="e => handleInput(e.target.value)"
      @focus="emitFocus"
      @blur="handleBlur"
      @keydown.delete.stop="e => e.stopPropagation()"
    />
    <slot
      name="after"
      :methods="{ focusInput }"
    ></slot>
    <i
      v-if="hasPlus"
      class="mdi mdi-plus numinput_arrow numinput_arrow_plus icon_btn"
      :class="{
        'no-events numinput_arrow_disabled': value >= max,
      }"
      data-tst="plus"
      @mousedown="e => setMousedownTimeout(e, step * 1)"
      @mouseup="clearTimeout"
      @mouseout="clearTimeout"
    />
    <slot
      name="after"
      :methods="{ focusInput }"
    ></slot>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import { throttle } from 'lodash'

export default {
  name: 'NumberInput',
  props: {
    value: { default: () => 0 },
    min: { default: () => 0 },
    max: { default: () => 100 },
    step: { default: () => 1 },
    hasWheelScroll: { type: Boolean, default: true },
    hasMinus: { type: Boolean, default: true },
    hasPlus: { type: Boolean, default: true },
    decimals: { default: 2 },
    inputmode: { default: 'decimal' },
    focusOperations: { default: () => ['selectText'] },
    tabindex: { default: 1 },
    focusOnMounted: Boolean,
    stopOnMin: { type: Boolean, default: true },
    tstPrefix: { type: String, default: '' },
  },
  emits: ['keydown', 'inputvalue', 'input', 'input:all', 'focus:input'],
  data() {
    return {
      tmtId: 0,
    }
  },
  mounted() {
    if (this.inputTabIndex === -1) return
    if (this.focusOnMounted) {
      nextTick(() => {
        this.focusInput(this.focusOperations)
      })
    }
  },
  methods: {
    handleInput(strNum, force) {
      this.$emit('inputvalue', strNum)

      const res = this.getParsedVal(strNum, force)

      if (!force && res.belowMin && this.stopOnMin) {
        // when min is 2 and you wanna input 10, you can write 1 and 0
        return
      }
      if (res.emitInput) {
        this.setHtmlInputVal(res.inputVal)
        this.$emit('input', res.numVal)
        this.$emit('input:all', res)
      } else {
        this.setHtmlInputVal(res.inputVal)
      }
    },

    handleBlur() {
      if (this.$refs.input?.value === this.value) return
      const value = this.$refs.input?.value || this.value
      this.handleInput(value, 'force')
    },
    getParsedVal(val, force) {
      // http://numeraljs.com/ TODO

      const origVal = val

      val = val.toString()
      val = val.trim()

      if (val === '00') {
        val = '0'
      }

      // decideSeparator
      let n = 1.1
      n = n.toLocaleString(this.$i18n.locale).substring(1, 2)
      val = val.replace(',', '.')
      val = val.replace('..', '.')
      val = val.replace('.', '.')
      val = val.replace(n, '.')
      if (val === '.') {
        val = '0.'
      }

      const available = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '-']
      val = val
        .split('')
        .filter(char => available.includes(char))
        .join('')

      let separatorIdx = val.indexOf('.')

      let res = {}
      const l = val.length

      if (
        // allow empty
        // disalow 00 01 etc
        // allow 0. 1. 2. etc
        // allow 0.00, 10 etc
        // allo -0.00, -10 etc
        !force &&
        (!l ||
          (val.includes('.') && !val[separatorIdx + 1]) ||
          !val[separatorIdx + 1] === '0' ||
          (val[0] === '-' && this.min < 0 && !Number(val)))
      ) {
        val = val.substring(0, separatorIdx !== -1 ? separatorIdx + 1 + this.decimals : val.length)
        res = {
          val,
          inputVal: val,
          emitInput: false,
        }
        // console.log(res)
      } else {
        let valParsed = parseFloat(val)
        valParsed = isNaN(valParsed) ? 0 : valParsed

        const belowMin = valParsed < this.min
        const aboveMax = valParsed > this.max
        if (belowMin || aboveMax) {
          val = Math.max(Math.min(valParsed, this.max), this.min)
        }
        val = val.toString()

        const numVal = parseFloat(
          val.substring(0, separatorIdx !== -1 ? separatorIdx + 1 + this.decimals : val.length),
        )

        separatorIdx = val.indexOf('.') // in case min or max has more decimals
        const inputVal = parseFloat(
          val.substring(0, separatorIdx !== -1 ? separatorIdx + 1 + this.decimals : val.length),
        )
          .toString()
          .replace('.', n) // return reparator to locale
        res = {
          val,
          emitInput: true,
          origVal,
          numVal,
          inputVal,
          valParsed,
          belowMin,
          aboveMax,
        }
      }
      // console.log(res, this.decimals)
      return res
    },
    setHtmlInputVal(val) {
      if (this.$refs.input) {
        // console.log('setHtmlInputVal', val)
        this.$refs.input.value = val
      }
    },
    handleArrowUp(e) {
      const step = this.step * (e.shiftKey ? 10 : 1)
      const val = Number((Number(this.value) + step).toFixed(this.decimals))
      this.passToHandleInput(val)
      this.focusInput()
    },
    handleArrowDown(e) {
      const step = this.step * (e.shiftKey ? 10 : 1)
      const val = Number((Number(this.value) - step).toFixed(this.decimals))
      this.passToHandleInput(val)
      this.focusInput(this.focusOperations)
    },
    handleMousedown(num) {
      this.clearTimeout()
      this.focusInput(this.focusOperations)
      const val = Number((Number(this.value) + num).toFixed(this.decimals))
      this.passToHandleInput(val)
    },
    handleWheel: throttle(function (e) {
      if (!this.hasWheelScroll) return

      e.stopPropagation()
      e.preventDefault()

      this.focusInput()
      e.preventDefault()
      let val = this.value

      const step = this.step * (e.shiftKey ? 10 : 1)
      if (e.deltaY < 0) {
        val += step
      } else {
        val -= step
      }
      this.passToHandleInput(val)
    }, 5),
    passToHandleInput(val) {
      val = val <= this.min ? this.min : val >= this.max ? this.max : val
      this.handleInput(val)
    },

    clearTimeout() {
      clearTimeout(this.tmtId)
    },
    setMousedownTimeout(e, step, time = 140) {
      step *= e.shiftKey ? 10 : 1
      this.handleMousedown(step)

      time = time > 80 ? time - 4 : time > 50 ? time - 4 : time - 2
      time = time < 1 ? 1 : time

      const ee = { shiftKey: e.shiftKey }
      this.tmtId = setTimeout(() => {
        this.setMousedownTimeout(ee, step, time - 1)
      }, time)
    },
    focusInput(focusOperations = []) {
      if (this.$refs.input) {
        this.$refs.input.focus()
        if (focusOperations.includes('selectText')) {
          this.$refs.input.select()
        }
      }
    },
    emitFocus() {
      this.$emit('focus:input')
    },
  },
}
</script>

<style lang="scss" scoped>
.numinput {
  --clr-focus: var(--clr-primary);
  --input-height: 1.5rem;
  --input-width: 2.75rem;
  --input-line-height: 1.2;

  --input-radius: 4px;
  --input-padding: 0px;

  --input-z-index: unset;

  --input-z-index-hover: 3;
  --input-z-index-focus: 3;

  --input-background: var(--clr-black-3);
  --input-color: var(--clr-white-0);
  --input-color-hover: var(--clr-white-0);

  --clr-outline: transparent;
  --input-shadow-focus: 0px 0px 0px 2px var(--clr-focus);

  --input-font-weight: 600;

  --input-clr-arrow: var(--input-color);
  --input-clr-arrow-disabled: var(--clr-black-5);

  display: flex;
  align-items: center;
  position: relative;

  &_arrow {
    font-size: 1.5rem;
    padding: 0.125rem;
    color: var(--input-clr-arrow);
    &_minus {
      margin-right: 0.25rem;
    }
    &_plus {
      margin-left: 0.25rem;
    }
    color: var(--input-clr-arrow);
    &_disabled {
      color: var(--input-clr-arrow-disabled);
    }
  }
  &_input {
    transition: box-shadow 0.2s;
    background: transparent;
    text-align: center;
    border-radius: var(--input-radius);
    width: var(--input-width);
    height: var(--input-height);
    line-height: var(--input-line-height);
    font-weight: var(--input-font-weight);
    background: var(--input-background);
    color: var(--input-color);
    box-shadow: var(--input-shadow);
    padding: var(--input-padding);
    z-index: var(--input-z-index);
    outline: var(--clr-outline) solid 1px;
    &:focus {
      --input-shadow: var(--input-shadow-focus);
      --input-z-index: var(--input-z-index-focus);
    }
  }
  &:hover {
    .numinput_input {
      --input-color: var(--input-color-hover);
      --input-shadow: var(--input-shadow-focus);
      --input-z-index: var(--input-z-index-hover);
    }
  }
}

.numinput_white {
  --input-background: var(--clr-white-0);
  --input-color: var(--clr-black-0);
  --input-color-hover: var(--clr-black-0);
  --input-clr-arrow: var(--clr-white-0);
}
</style>
